<template>
   <v-card class="pa-4 box_shadow_class mt-0">
  <div>
    <!-- header -->
    <HeaderComponent :headerTitle="headerText" class="header-fixed" style="width: 98%;" />
    <!-- content -->
    <v-container fluid grid-list-lg pt-0>
      <v-card class="v-card-100 p-5" row wrap>
        <v-row>
          <v-col xs1 cols="2" sm="2" md="2" class="Content-box mr-6 cursor-pointer" @click="navigateTarget('tourVisit')" :class="{ 'disabled-span' : roles.includes('logistics_partners_manager') }">            <div>
              <div align="center" justify="center">
                <img class="mt-7 image-size" src="@/assets/images/ftaImages/tours.png" />
              </div>
              <div class="mt-7" align="center" justify="center">
                <span class="title">Tour Plan</span>
              </div>
            </div>
          </v-col>
          <v-col xs1 cols="2" sm="2" md="2" class="Content-box mr-6 cursor-pointer" @click="navigateTarget('serviceRequest')" :class="{ 'disabled-span' : roles.includes('logistics_partner') }">
            <div>
              <div align="center" justify="center">
                <img class="mt-7 image-size" src="@/assets/images/ftaImages/partner.png" />
              </div>
              <div class="mt-7" align="center" justify="center">
                <span class="title">Partner Request</span>
              </div>
            </div>
          </v-col>
            <v-col xs1 cols="2" sm="2" md="2" class="Content-box mr-6 cursor-pointer" @click="navigateTarget('ftaReverseLogistics')" :class="{ 'disabled-span' : roles.includes('logistics_manager') }">
            <div>
              <div align="center" justify="center">
                <img class="mt-7 image-size" src="@/assets/images/icons/reverse_logistics.svg" />
              </div>
              <div class="mt-7" align="center" justify="center">
                <span class="title">Reverse Logistics</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</v-card>
</template>
<script>
  import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
  export default {
    data() {
      return {
        headerText: "FTA",
        roles : [],
      }
    },
    components: {
      HeaderComponent
    },
    created(){
      this.roles = this.$store.state.currentUser.roles     
    },
    methods: {
      navigateTarget(routerName) {
        this.$store.commit("tourVisits", {
          action: ''
        });
        if(routerName == 'ftaReverseLogistics'){
          this.$store.commit("setHeaderTextName",{
            headerTextName : 'FTA'
          })
        };
        this.$router.push({ name: routerName });
      }
    },
  }
</script>
<style>
  .fta-container{
    height: 88vh;
  }
  .Content-box{
    border: 1px solid #000 !important;
    border-radius: 8px !important;
    width: 200px;
    height: 200px;
  }
  .image-size {
    width: 50px !important;
    height: 50px !important;
  }
  .cursor-pointer:hover {
    cursor: pointer !important;
  }
  .disabled-span {
    pointer-events: none; 
    opacity: 0.5;
    color: gray;
  }
</style>